<template>
  <div>
    <v-container>
      <v-row
        justify="start"
        align="center"
        md="8">
        <v-col>
          <div>
            <h1>Prosenseでプログラミング指導</h1>
          </div>
          <div>
            <h2>
              <v-icon>done_outline</v-icon><span>「リクエスト」で生徒とつながる</span><br>
              <v-icon>done_outline</v-icon><span>「授業に応募」で簡単に授業予定が組める</span><br>
              <v-icon>done_outline</v-icon><span>報酬はLinepayで受け取り</span>
            </h2>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-btn
            color="primary"
            rounded
            @click="display=!display">
            授業までの流れ<v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col>
          <v-btn
            color="primary"
            rounded
            @click="$router.push(`/teacher/signup`)">
            まずは無料登録
          </v-btn>
        </v-col>
      </v-row>
    </v-container> 
    <v-container>
      <v-timeline 
        v-if="display"
        :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item>
          <v-card>
            <v-card-title>プロフィール登録</v-card-title>
            <v-card-text>
              プロフィール画面から教師情報を入力してください。<br>
              プロフィール条件が合えば家庭からリクエストが届きます。
            </v-card-text>
          </v-card>
        </v-timeline-item>
        <v-timeline-item>
          <v-card>
            <v-card-title>リクエストを送る</v-card-title>
            <v-card-text>
            条件面で指導可能な生徒にリクエストを送ることができます。<br>
            リクエストが承認されると、授業への応募ができます。<br>
            承認された生徒は「生徒一覧」で確認できます。
            </v-card-text>
          </v-card>
        </v-timeline-item>
        <v-timeline-item>
          <v-card>
            <v-card-title>授業への応募</v-card-title>
            <v-card-text>
              「授業への応募」で希望する日程、報酬額を提示しましょう。<br>
              応募が採用されると、毎週の授業予定として授業予定に追加されます。<br>
              反対に家庭から授業依頼が届いた場合にはしっかり回答しましょう。
            </v-card-text>
          </v-card>
        </v-timeline-item>
        <v-timeline-item>
          <v-card>
            <v-card-title>授業を行う</v-card-title>
            <v-card-text>
              あなたのスキルを存分に指導に生かしてください。<br>
              授業が完了すると家庭から授業記録が作成されます。
            </v-card-text>
          </v-card>
        </v-timeline-item>
        <v-timeline-item>
          <v-card>
            <v-card-title>報酬を受け取る</v-card-title>
            <v-card-text>
              毎月○日にLINE Payにて報酬を受け取れます。<br>
              詳細は「授業予定」の報酬額を参照してください。
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'TeacherStart',
  data() {
    return {
      display: false
    }
  },

}
</script>

<style scoped>
/* .main--text {
  font-family: 'M PLUS Rounded 1c', sans-serif;
} */
/* .main {
  background-color: rgb(255, 255, 255)
} */
</style>



